import { render } from "./StudentEmailList.vue?vue&type=template&id=70d0cb9e&scoped=true"
import script from "./StudentEmailList.vue?vue&type=script&lang=js"
export * from "./StudentEmailList.vue?vue&type=script&lang=js"

import "./StudentEmailList.vue?vue&type=style&index=0&id=70d0cb9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d0cb9e"]])

export default __exports__